import { createSlice } from "@reduxjs/toolkit";
import {  addEditFavouriteAPI, claimNonprofitAPI, countriesAPI, editNonprofitProfileAPI, fetchNonprofitProfileAPI, issuesAPI, statesAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
  states:null,
  countries:null,
  issues:null,
};

const editNonprofitProfileSlice = createSlice({
  name: "editNonprofitProfile",
  initialState: data,
  reducers: {
    editNonprofitProfileSlice(state) {
      state.isLoading = true;
    },
    fetchNonprofitProfileSliceSuccess(state, action) {
      state.isLoading = false;
      state.data=action.payload
      state.message = null;
    },
    editNonprofitProfileSliceSuccess(state, action) {
      state.isLoading = false;
      state.message = null;
    },
    commonStatesSliceSuccess(state, action) {
      state.isLoading = false;
      state.states = action.payload;
      state.message = null;
    },
    commonCountriesSliceSuccess(state, action) {
      state.isLoading = false;
      state.countries = action.payload;
      state.message = null;
    },
    commonIssuesSliceSuccess(state, action) {
      state.isLoading = false;
      state.issues = action.payload;
      state.message = null;
    },
    editNonprofitProfileSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    editNonprofitProfileSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.error = "";
    },
    commonStatesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.states = null;
      state.error = "";
    },
    commonCountriesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.countries = null;
      state.error = "";
    },
    commonIssuesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.issues = null;
      state.error = "";
    },
  },
});

export const fetchNonprofitProfileHandler = (org_id:string) => async (dispatch: any) => {
  try {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSlice());
    const response: any = await fetchNonprofitProfileAPI(org_id);
    dispatch(editNonprofitProfileAction.fetchNonprofitProfileSliceSuccess(response));
  } catch (e: any) {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceFailure(e?.response?.data?.message));
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceReset());
  }
};
export const editNonprofitProfileHandler = (org_id:string,body:any) => async (dispatch: any) => {
  try {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSlice());
    const response: any = await editNonprofitProfileAPI(org_id,body);
    dispatch(fetchNonprofitProfileHandler(org_id));
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceFailure(e?.response?.data?.message));
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const commonStatesDataHandler = () => async (dispatch: any) => {
  try {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSlice());
    const response: any = await statesAPI();
    dispatch(editNonprofitProfileAction.commonStatesSliceSuccess(response));
  } catch (e: any) {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceFailure(e?.response?.data?.message));
    dispatch(editNonprofitProfileAction.commonStatesSliceReset());
  }
};

export const commonCountriesDataHandler = () => async (dispatch: any) => {
  try {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSlice());
    const response: any = await countriesAPI();
    dispatch(editNonprofitProfileAction.commonCountriesSliceSuccess(response));
  } catch (e: any) {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceFailure(e?.response?.data?.message));
    dispatch(editNonprofitProfileAction.commonCountriesSliceReset());
  }
};
export const commonIssuesDataHandler = () => async (dispatch: any) => {
  try {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSlice());
    const response: any = await issuesAPI();
    dispatch(editNonprofitProfileAction.commonIssuesSliceSuccess(response));
  } catch (e: any) {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceFailure(e?.response?.data?.message));
    dispatch(editNonprofitProfileAction.commonIssuesSliceReset());
  }
};
export const addEditFavioriteHandler = (user_id:string,org_id:string) => async (dispatch: any) => {
  try {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSlice());
    const response:any=await addEditFavouriteAPI(user_id,org_id);
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceFailure(e?.response?.data?.message));
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const claimNonprofitHandler = (org_id:string) => async (dispatch: any) => {
  try {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSlice());
    const response:any= await claimNonprofitAPI(org_id);
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(editNonprofitProfileAction.editNonprofitProfileSliceFailure(e?.response?.data?.message));
    showErrorToast(e?.response?.data?.error_message)
  }
};

export default editNonprofitProfileSlice.reducer;
export const editNonprofitProfileAction = editNonprofitProfileSlice.actions;
